
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/strumenti-servizi/tailor-made",
      function () {
        return require("private-next-pages/strumenti-servizi/tailor-made/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/strumenti-servizi/tailor-made"])
      });
    }
  